import React from 'react';

import { flagStyles } from '../settings';

const SvgIN = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-2472px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgIN;
